import { Typography, Avatar, Button } from '@mui/material'
import { Link } from 'react-router-dom'
import LogoBloomberg from 'assets/logos/bloomberg.png'
import LogoOwler from 'assets/logos/owler.png'
import LogoIM from 'assets/logos/investor_master.png'
import LogoCsv from 'assets/logos/csv.png'
import SectionCard from './SectionCard'

function IntegrationsCard() {
  return (
    <SectionCard title="Data Integrations" lock>
      <Typography variant="body2">External data or your own data</Typography>
      <br />
      <div style={{ textAlign: 'right', marginBottom: '10px' }}>
        <Avatar
          src={LogoBloomberg}
          variant="square"
          sx={{ display: 'inline-block', marginLeft: '22px', height: '50px', width: '50px' }}></Avatar>
        <Avatar
          src={LogoOwler}
          variant="square"
          sx={{ display: 'inline-block', marginLeft: '22px', height: '50px', width: '50px' }}></Avatar>
        <Avatar
          src={LogoIM}
          variant="square"
          sx={{ display: 'inline-block', marginLeft: '22px', height: '50px', width: '50px' }}></Avatar>
        <Avatar
          src={LogoCsv}
          variant="square"
          sx={{ display: 'inline-block', marginLeft: '22px', height: '50px', width: '50px' }}></Avatar>
      </div>
      <Button variant="contained" sx={{ mr: 5 }} component={Link} to="/report">
        Manage
      </Button>
    </SectionCard>
  )
}

export default IntegrationsCard
